var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66669 10.5274V3.08078L9.92002 6.33411C10.18 6.59411 10.6067 6.59411 10.8667 6.33411C11.1267 6.07411 11.1267 5.65411 10.8667 5.39411L6.47335 1.00078C6.3488 0.875941 6.1797 0.805786 6.00335 0.805786C5.82701 0.805786 5.65791 0.875941 5.53335 1.00078L1.13335 5.38744C0.873355 5.64744 0.873355 6.06744 1.13335 6.32744C1.39335 6.58744 1.81335 6.58744 2.07335 6.32744L5.33335 3.08078V10.5274C5.33335 10.8941 5.63335 11.1941 6.00002 11.1941C6.36669 11.1941 6.66669 10.8941 6.66669 10.5274Z",
    fill: "#1D986B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.b00780512ec9109f35ff89a84f854af1.svg";
export { ForwardRef as ReactComponent };